$(document).ready(function(){
  // icon slider for mobile
    function initializeSlider() {
        $('.devListIcons').slick({
            dots: true,
            infinite: false,
            speed: 300,
            arrows: false,
            slidesToShow: 3,
            adaptiveHeight: true,
            slidesToScroll: 3
        });
    }

    if ($(window).width() < 767) {
        initializeSlider(); 
    }

    $(window).resize(function() {
        if ($(window).width() < 767) {
            initializeSlider(); 
        } else {
            if ($('.devListIcons').hasClass('slick-initialized')) {
                $('.devListIcons').slick('unslick');
            }
        }
    });


  // work station section
       $('.SlidesBlocks').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg></button>',
      asNavFor: '.devTabsBlock'
    });
    $('.devTabsBlock').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.SlidesBlocks',
      dots: false,
      focusOnSelect: true
    });

    
  
  // instafeed slider 

  $('.devInstaMainGrid').slick({
  dots: false,
  infinite: true,
  speed: 300,
  arrows:true,  
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows:true,  
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows:false, 
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        autoplay:true,
        arrows:false,
      }
    }
  ]
});


  // custom Review Slider home
  $('.devReviewDesign').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg></button>',
     responsive: [
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows:false,
        dots: true
      }
     }
       ]
   });

    function initializeSlider1() {
        $('.devSingleGallery').slick({
            dots: true,
            infinite: false,
            speed: 300,
            arrows: true,
            slidesToShow: 1,
            adaptiveHeight: true,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg></button>',
    
        });
    }

    if ($(window).width() < 767) {
        initializeSlider1(); 
      // initializeSlider(); 
    }

    $(window).resize(function() {
        if ($(window).width() < 767) {
            initializeSlider1(); 
            // initializeSlider(); 
        } else {
            if ($('.devSingleGallery').hasClass('slick-initialized')) {
                $('.devSingleGallery').slick('unslick');
            }
        }
    });


      function initializeSlider2() {
        $('.devProdGridCard').slick({
            dots: true,
            infinite: false,
            speed: 300,
            arrows: false,
            slidesToShow: 2,
            adaptiveHeight: true,
            slidesToScroll: 2
    
        });
    }

    if ($(window).width() < 767) {
        initializeSlider2(); 
      // initializeSlider(); 
    }

    $(window).resize(function() {
        if ($(window).width() < 767) {
            initializeSlider2(); 
            // initializeSlider(); 
        } else {
            if ($('.devProdGridCard').hasClass('slick-initialized')) {
                $('.devProdGridCard').slick('unslick');
            }
        }
    });
});
